var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_2967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 2.97925C11.5174 2.97925 7.08325 7.41342 7.08325 12.8959C7.08325 20.3334 16.9999 31.3126 16.9999 31.3126C16.9999 31.3126 26.9166 20.3334 26.9166 12.8959C26.9166 7.41342 22.4824 2.97925 16.9999 2.97925ZM9.91658 12.8959C9.91658 8.98592 13.0899 5.81258 16.9999 5.81258C20.9099 5.81258 24.0832 8.98592 24.0832 12.8959C24.0832 16.9759 20.0032 23.0818 16.9999 26.8926C14.0533 23.1101 9.91658 16.9334 9.91658 12.8959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 16.4376C18.9559 16.4376 20.5416 14.8519 20.5416 12.8959C20.5416 10.9399 18.9559 9.35425 16.9999 9.35425C15.0439 9.35425 13.4583 10.9399 13.4583 12.8959C13.4583 14.8519 15.0439 16.4376 16.9999 16.4376Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_2967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0 0.145996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3ab847e91801f9b2db162ae6294b3b58.svg";
export { ForwardRef as ReactComponent };